import { showErrorToast, showSuccessToast } from "../helpers/toast";

/**
 * トースト表示用のVueプラグイン
 */
export default {
    install(Vue) {
        /**
         * エラートーストを表示する
         *
         * @param {string} message - 表示するエラーメッセージ
         * @param {boolean} isShowErrorIcon - 表示するアイコン
         */
        Vue.prototype.$showErrorToast = function (
            message,
            isShowErrorIcon = true
        ) {
            showErrorToast(this, message, isShowErrorIcon);
        };

        /**
         * 成功トーストを表示する
         *
         * @param {string} message - 表示するメッセージ
         */
        Vue.prototype.$showSuccessToast = function (message) {
            showSuccessToast(this, message);
        };
    },
};
